module.exports = __webpack_public_path__ + "static/DS_birthday_kid-7a5e6b1ccac95fdbb7e32bdd940a9aa2.jpg";